import { Grid } from '@material-ui/core';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import {
  HomePageStarredEntities,
  HomePageToolkit,
  WelcomeTitle,
} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';

export const HomePage = () => (
  <Page themeId="home">
    <Header title={<WelcomeTitle />} />
    <Content>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SearchContextProvider>
            <HomePageSearchBar placeholder="Search" />
          </SearchContextProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <HomePageStarredEntities />
        </Grid>
        <Grid item xs={12} md={6}>
          <HomePageToolkit
            tools={[
              { url: '/catalog', label: 'Catalog', icon: <></> },
              { url: '/create', label: 'Create', icon: <></> },
              { url: '/docs', label: 'TechDocs', icon: <></> },
            ]}
          />
        </Grid>
      </Grid>
    </Content>
  </Page>
);
